<nz-page-header nz-affix *ngIf="generatingRes == 0">
  <nz-page-header-title>
    {{'Return Wizard' | locale }}
  </nz-page-header-title>
  <nz-page-header-extra>
  </nz-page-header-extra>
</nz-page-header>
<nz-page-header nz-affix nzBackIcon *ngIf="generatingRes != 0" (nzBack)="ngOnInit()">
  <nz-page-header-title>
    {{'Return Wizard' | locale }}
  </nz-page-header-title>
  <nz-page-header-extra>
  </nz-page-header-extra>
</nz-page-header>
<nz-collapse *ngIf="generatingRes == 0">
  <nz-collapse-panel nzHeader="Filter" nzActive="true">
    <app-wizard-filter-section [filterFields]="filterFields" (filterButtonClicked)="getItemsToReturn()"
      [filterButtonIsLoading]="openDocumentsIsLoading">
    </app-wizard-filter-section>
  </nz-collapse-panel>
</nz-collapse>

<nz-space style="width: 100%" *ngIf="generatingRes == 0" nzDirection="vertical">
  <nz-space-item>
    <app-table-section [tableCols]="openItemsTableCols" [dataset]="dataTable.dataset" [tableName]="dataTable.name"
      [cellSettings]="cellSettings">
    </app-table-section>
  </nz-space-item>
  <nz-space-item>
    <button nz-button nzType="primary" (click)="generateReturns()" [nzLoading]="generatingIsLoading">
      {{'Submit' | locale }}</button>
  </nz-space-item>
</nz-space>

<ng-container *ngIf="generatingRes != 0"></ng-container>

<nz-result *ngIf="generatingRes != 0" [nzStatus]="generatingRes == 2?'info': 'error'" [nzTitle]="generatingResTitle"
  [nzSubTitle]="generatingResMessage">
</nz-result>

<app-table-section *ngIf="generatingRes == 2" [tableCols]="resultTableCols" [dataset]="resultDataTable.dataset"
  [tableName]="resultDataTable.name" [cellSettings]="resultCellSettings">
</app-table-section>
